import { memo, useContext } from "react";
import Loader from "../../Loader";
import NoData from "../../../sharedComponent/NoData";
import optionIcon from "../../../assets/images/bx_edit.svg";
import DelectAcBlc from "../../../assets/images/DelectAcBlc.svg";
import eye_icon from "../../../assets/images/eye_icon.svg";
import { AppContext } from "../../../context/AppContext";


const TaskPlanListing = memo((props) => {

    const { loading, taskList, setIsEditTask, getTask, search, perPage, startIndex, currentSelectedProject } = props

    const { permissions } = useContext(AppContext)

    const handleOpen = (id) => {
        setIsEditTask(true)
    }


    return (
        <>
            <div
                className="table-wrapper"
                id="scrol-tbl"
                style={{ marginBottom: "55px" }}
            >

                {loading ? (
                    <div style={{ marginTop: "150px" }}>
                        <Loader />
                    </div>
                ) :
                    taskList?.length ?
                        <table>
                            <tr className="firstTabelRow">
                                <th>Sr. no.</th>
                                <th>Title Name</th>
                                <th>Project Name</th>


                                <th>Action</th>

                            </tr>
                            {
                                taskList?.slice(startIndex, startIndex + perPage)?.map((task, index) => {
                                    return <tr className="table-row-custom">
                                        <td id="sr-no-padding">{startIndex + index + 1}</td>
                                        <td>{task?.filename}</td>
                                        <td>{task?.project?.projectName}</td>


                                        <td>

                                            <img
                                                src={eye_icon}
                                                onClick={() => getTask(task?.id)}
                                                className="mx-2 pointer"
                                                alt=""
                                            />
                                            {
                                                permissions && permissions['Delete Task Planner'] &&
                                                <img
                                                    src={DelectAcBlc}
                                                    // onClick={() => getTask(item.TasKId)}
                                                    className="deleteBtn"
                                                    alt=""

                                                />
                                            }


                                        </td>

                                    </tr>
                                })
                            }

                        </table>
                        : (
                            <>
                                <NoData />
                            </>
                        )
                }
            </div>
        </>
    )


})

export default TaskPlanListing